export default __webpack_public_path__ + "img/consultation_follow_up-7b0219aaf564fabab739293a469e994c.png";